<template>
  <div class="list-wrapper">
    <!-- <dv-loading v-if="loading">Loading...</dv-loading> -->
    <!-- <div v-for="item in list" class="item">
      <div class="item-rank" >
        <img class="item-rank-img" v-if="item.rank == 1" src="../../../assets/rank1.png" />
        <img class="item-rank-img" v-if="item.rank == 2" src="../../../assets/rank2.png" />
        <img class="item-rank-img" v-if="item.rank == 3" src="../../../assets/rank3.png" />
        <img class="item-rank-img" v-if="item.rank > 3" src="../../../assets/rank.png" />
        <span class="item-rank-number">{{ item.rank }}</span>
      </div>
      <div
        class="item-content"
        :class="{'item-content1': item.rank == 1, 'item-content2': item.rank == 2, 'item-content3': item.rank == 3, 'item-content4': item.rank > 3 && item.rank < 8}">
        <img class="item-avatar" :src="item.pic" />
        <span class="item-name">{{ item.name }}</span>
        <span class="item-money">{{ item.money }}</span>
      </div>
    </div> -->

    <div class="rank">
      <Echart :options="options1" height="205px"></Echart>
    </div>
    <div class="rank">
      <Echart :options="options2" height="205px"></Echart>
    </div>
    <div class="rank">
      <Echart :options="options3" height="205px"></Echart>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";

export default {
  components: {
    Echart,
  },
  data() {
    return {
      list: [],
      intvl3: null,
      loading: false,
      colors: [
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: 'rgba(255, 41, 41, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(7, 6, 45, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: 'rgba(255, 152, 0, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(255, 152, 0, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: 'rgba(255, 210, 0, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(255, 210, 0, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        
      ],
      options1: {},
      options2: {},
      options3: {},
    }
  },
  created() {
    // for (let i = 0; i < 17; i++) {
    //   this.list.push({
    //     rank: i + 1,
    //     name: '嗨团销冠TTBasdada',
    //     money: 232434123131.21,
    //     pic: ''
    //   })
    // }
    for (let i = 3; i < 10; i++) {
      this.colors[i] = (
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: 'rgba(78, 155, 255, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(7, 6, 45, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        })
    }
    for (let i = 10; i < 21; i++) {
      this.colors[i] = (
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0, color: 'rgba(24, 42, 127, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(24, 42, 127, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
      })
    }

    // console.log(this.colors);


    this.getData()
  },
  destroyed() {
    clearInterval(this.intvl3)
  },
  methods: {
    loadChart() {
      for (let i = 1; i <= 3; i++) {
        this[`options${i}`] = {
          grid: [
            {
              top: 45,
              bottom: 0,
              left: 40,
              right: 0,
              // width: '33%',
              // containLabel: true
            },
          ],
          xAxis: [
            {
              type: 'value',
              max: this.list[0].order_count,
              splitLine: { show: false },
              axisTick: { show: false },
              axisLine: { show: false },
              axisLabel: {
                show: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'category',
              splitLine: { show: false },
              z: 4,
              axisTick: { show: false },
              axisLine: { show: false },
              inverse: true,
              animationDuration: 300,
              animationDurationUpdate: 300,
              max: 6, // only the largest 7 bars will be displayed
              axisLabel: {
                show: true,
                inside: true,
                margin: -30,
                align: 'left',
                verticalAlign: 'middle',
                formatter: (item, index) => {
                  let arrays = item.split("##")
                  return `{${arrays[0]}|} {headimg${arrays[0]}|} ${arrays[2]}`
                },
                rich: {
                  ...this[`list${i}`].reduce((total, current, currentIndex, origin) => {
                    total[`${current.rank}`] = {
                      backgroundColor: {
                        image: `https://suicdn.htchaxun.cn/bigdata/number/${current.rank}.png`
                      },
                      borderRadius: 20
                    }
                    return total
                  }, {}),
                  ...this[`list${i}`].reduce((total, current, currentIndex, origin) => {
                    total[`headimg${current.rank}`] = {
                      height: 16,
                      backgroundColor: {
                        image: `https://suicdn.htchaxun.cn/bigdata/default_headimgurl.png`
                      },
                      borderRadius: 20
                    }
                    return total
                  }, {}),

                },
              },
              data: this[`list${i}`].map((item, index) => {
                return `${item.rank}##${item.pic}##${item.name}`
              }),
            },
          ],
          series: [
            {
              // xAxisIndex: 0,
              // yAxisIndex: 0,
              realtimeSort: true,
              type: 'bar',
              stack: `chart${i}`,
              label: {
                show: false,
                position: 'insideBottomRight',
                color: 'transparent',
                fontSize: '10',
                align: 'right',
                verticalAlign: 'middle',
                valueAnimation: true
              },
              animationDuration: 300,
              animationDurationUpdate: 300,
              data: this[`list${i}`].map((item, index) => {
                return {
                  value: item.order_count,
                  itemStyle: {
                    color: this.colors[(i - 1) * 7 + index]
                  }
                }
              }),
            },
            {
              // xAxisIndex: 0,
              // yAxisIndex: 0,
              type: 'bar',
              stack: `chart${i}`,
              label: {
                show: true,
                position: 'insideRight',
                color: '#FFFFFF',
                fontSize: '10',
                align: 'right',
                verticalAlign: 'middle',
                precision: 1,
                valueAnimation: true,
                formatter: (val) => {
                  let num = this.list[0].order_count - val.data.value
                  return num
                }
              },
              animationDuration: 300,
              animationDurationUpdate: 300,
              data: this[`list${i}`].map((item, index) => {
                return {
                  value: this.list[0].order_count - item.order_count,
                  itemStyle: {
                    color: 'transparent'
                  }
                }
              }),
            },
          ],
          animationDuration: 3000,
          animationDurationUpdate: 3000,
          animationEasing: 'linear',
          animationEasingUpdate: 'linear'
        }
      }
      // console.log("inthis", this.options1);
    },
    getData() {
      this.getDataFunc()
      this.intvl3 = setInterval(() => {
        this.getDataFunc()
      }, 3000)
    },
    getDataFunc() {
      this.loading = true
      this.list = []
      fetch('https://mng.htchaxun.cn/index/total_data/today_team_sales', { methods: 'get' }).then(response => {
        return response.json()
      }).then(res => {
        res.data.data.forEach((item, index) => [
          this.list.push({
            rank: index + 1,
            name: item.team_name,
            money: item.sales,
            pic: item.headimgurl,
            order_count: item.order_count
          })
        ])

        this.list1 = this.list.slice(0, 7)
        this.list2 = this.list.slice(7, 14)
        this.list3 = this.list.slice(14, 21)
        // console.log(this.list1);
        this.loadChart()
      }).catch(() => { }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  // margin: 50px 20px 0 20px;
  // height: 150px;
  // width: 33%;
  // justify-content: space-between;
  // overflow: hidden;

  .rank {
    width: 33%;
    // flex-grow: 1;
    flex-shrink: 0;
  }

  // .item {
  //   width: 33.3%;
  //   display: flex;
  //   margin-bottom: 3px;
  //   justify-content: center;
  //   align-content: center;

  //   .item-rank {
  //     position: relative;
  //     width: 20px;
  //     height: 15px;
  //     padding-top: 1.5px;

  //     .item-rank-img {
  //       width: 20px;
  //       height: 15px;
  //     }

  //     .item-rank-number {
  //       position: absolute;
  //       line-height: 15px;
  //       width: 16px;
  //       text-align: center;
  //       vertical-align: middle;
  //       left: 0;
  //       z-index: 1;
  //       font-size: 12px;
  //       font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  //       font-weight: bold;
  //       color: #FFFFFF;
  //     }
  //   }

  //   .item-content1 {
  //     background-image: url(../../../assets/rankbg1.png) !important;
  //   }

  //   .item-content2 {
  //     background-image: url(../../../assets/rankbg2.png) !important;
  //   }

  //   .item-content3 {
  //     background-image: url(../../../assets/rankbg3.png) !important;
  //   }

  //   .item-content4 {
  //     background-image: url(../../../assets/rankbg.png) !important;
  //   }

  //   .item-content {
  //     height: 18px;
  //     line-height: 18px;
  //     vertical-align: middle;
  //     background-size: contain;
  //     font-size: 12px;
  //     font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  //     font-weight: 400;
  //     color: #FFFFFF;
  //     position: relative;
  //     margin-left: 9px;
  //     width: 155px;

  //     .item-avatar {
  //       position: absolute;
  //       left: -9px;
  //       width: 18px;
  //       height: 18px;
  //       border-radius: 50%;
  //     }

  //     .item-name {
  //       display: inline-block;
  //       margin-left: 15px;
  //       width: 55px;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: nowrap;
  //     }

  //     .item-money {
  //       display: inline-block;
  //       margin-left: 6px;
  //       width: 76px;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       white-space: nowrap;
  //     }
  //   }
  // }
}
</style>